import { ProductType } from '@/AppGlobal';
import { ModifyEmployeeInfo } from '@/interface/vhkPub';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  employuserInfo: ModifyEmployeeInfo;
  productType: ProductType;
  fromConfirmInfo: boolean;
}

const initialEmployeeInfo: ModifyEmployeeInfo = {
  company: '',
  companyAddress: '',
  companyAddress1: '',
  companyAddress2: '',
  companyAddress3: '',
  companyPhone: '',
  countryRegion: '',
  incomes: 0,
  jobType: '',
  pay: 0,
  region: '',
  userJob: '',
  userTrade: '',
};

const initialState: CommonState = {
  employuserInfo: initialEmployeeInfo,
  productType: ProductType.KKC,
  fromConfirmInfo: false,
};

const employInfor = createSlice({
  name: 'employStore',
  initialState,
  reducers: {
    setemployUserInfo(state: CommonState, action: PayloadAction<ModifyEmployeeInfo>) {
      state.employuserInfo = action.payload;
    },

    clearemployUserInfo(state: CommonState) {
      state.employuserInfo = initialEmployeeInfo;
    },
    setEmployeeInfoProductType(state: CommonState, action: PayloadAction<ProductType>) {
      state.productType = action.payload;
    },
    setFromConfirmInfo(state: CommonState, action: PayloadAction<boolean>) {
      state.fromConfirmInfo = action.payload;
    },
  },
});

const { setemployUserInfo, clearemployUserInfo, setEmployeeInfoProductType, setFromConfirmInfo } =
  employInfor.actions;

export { setemployUserInfo, clearemployUserInfo, setEmployeeInfoProductType, setFromConfirmInfo };

export default employInfor.reducer;
